import Vue from 'vue';
import Vuex from 'vuex';
// import cart from './modules/cart';
import data from './modules/data';
// import products from './modules/products';
import auth from './modules/auth';
import messages from './modules/messages';
import navigation from './modules/navigation';
import courseManagement from './modules/course-management';
import courseCalendar from './modules/course-calendar';
import reports from './modules/reports';
import createPersistedState from "vuex-persistedstate";

import * as actions from './actions';

Vue.use(Vuex);

export default new Vuex.Store({
	actions,
	modules: {
		auth,
		data,
		// cart,
		// products,
		messages,
		navigation,
		courseManagement,
		courseCalendar,
		reports
	},
	plugins: [createPersistedState({
		paths: ['auth'],
	})]
});